

































































import {
  InstallationModule,
  InstallationModuleData,
  InstallationPlan,
  MechanicInstallation,
} from '@/types';

import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    installation: Object as PropType<MechanicInstallation>,
    module: Object as PropType<InstallationModule>,
    closeable: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    data(): InstallationModuleData {
      return this.module.data || {};
    },

    plan(): InstallationPlan {
      return this.module.installationPlan!;
    },

    gridSize(): number {
      return (
        this.installation?.screening?.numberOfPanels ??
        this.data.grid?.reduce((i, val) => i + (val ? 1 : 0), 0) ??
        0
      );
    },
  },
});
